import React, { Component } from 'react';
import StyleSheet from 'stilr';
import { Grid, Cell, palm } from 'react-flexr';
import domQuery from 'dom-helpers/query';
import { FAIcon } from '../icons';

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    fontSize: 20,
    // background: '#eeeeee',
    // color: '#424242',
    background: '#2196F3',
    color: '#ffffff',
    padding: '5px 15px',
    whiteSpace: 'nowrap',
    transform: 'translatez(0)',
    WebkitOverflowScrolling: 'touch' /*,
    borderBottom: '1px solid #dddddd'*/
  },
  value: {
    textAlign: 'right'
  },

  sticky: {
    position: 'fixed',
    zIndex: 1000,
    WebkitBackfaceVisibility: 'hidden'
  },

  toggleSearch: {
    marginRight: '1em'
  }
});

class Counter extends Component {
  getPosition = () => {
    if (this.props.sticky) {
      return this._offset || { top: 0 };
    }
    return (this._offset = (this._node && domQuery.offset(this._node)) || {
      top: 0
    });
  };

  toggleSearch = () => {
    if (this.props.toggleSearch) {
      const pos = this.getPosition() || { top: 11 };
      window.scrollTo(0, pos.top - 11);
      this.props.toggleSearch(true);
    }
  };

  render() {
    const { label, value, total, sticky } = this.props;
    return (
      <div
        ref={node => (this._node = node)}
        className={`${styles.container} ${sticky ? styles.sticky : ''}`}
      >
        <Grid style={{ marginBottom: 0 }}>
          <Cell className={styles.label} style={{ fontSize: 'large' }}>
            {sticky && FAIcon('sliders', { className: styles.toggleSearch, onClick: this.toggleSearch })}
            {label}
          </Cell>
          <Cell className={styles.value}>
            <strong>{value}</strong>
            {total ? <small> / {total}</small> : null}
          </Cell>
        </Grid>
      </div>
    );
  }
}

export default Counter;
